import "../Common/css/styles.css";
import logo from "../Assets/Images/logo.png";
import { ReactElement } from "react";
import text from "../Assets/Text/Text.json"

interface Props {
  children: ReactElement;
}

export default function AuthRegister({ children }: Readonly<Props>) {
  return (
    <div className="main-outer-container moc">
      <div className="login-container">
        <div className="login-header">
          <img className="logo" src={logo} alt="" />
          <span className="login-header-text">{text.authLoginPage.header}</span>
        </div>
        <div className="login-content-container middle">
          <div className="login-outer1">{children}
          </div>
        </div>
      </div>
    </div>
  );
}
